// Spawners (Experimental, mechanics §17.4; architecture §9.3): the virus style in the spawner
// colour (theme.json `spawner`), rotating slowly at 0.2 rad/s (held still with Reduce motion),
// or `world/spawner.png` (side 2.3 × r, rotated the same way) when present.

import type { Frame } from './frame.js';
import { type BodyShape, drawSpikyBody, type SpikeArt, VIRUS_STYLE } from './viruses.js';

const TAU = Math.PI * 2;

/** The spawner's rotation (radians) at `nowMs`. */
export function spawnerRotation(nowMs: number, reduceMotion: boolean): number {
  return reduceMotion ? 0 : ((nowMs / 1000) * VIRUS_STYLE.spawnerRadPerSec) % TAU;
}

export function drawSpawner(f: Frame, shape: BodyShape, art: SpikeArt): void {
  drawSpikyBody(
    f,
    shape,
    shape.r,
    f.theme.spawner,
    spawnerRotation(f.nowMs, f.reduceMotion),
    art.spawner,
  );
}
